<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link to="/aliados" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
            </div>
          </div>
          <div class="col-lg-12">
            <h3 class="text-orange">Aliados por agente</h3>
            <hr />
          </div>
        </div>
      </transition>
      <div class="card card-body">
        <div class="form-group">
          <label>Agente</label>
          <v-select v-model="agente" @input="get_resumen" label="nombre_completo" :options="agentes"></v-select>
        </div>
        <div>
          <div class="row" v-if="agente == null | agente == ''">
            <div class="col-lg-6">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">Aliados por agentes</h5>
                </div>
                <div class="card-body">
                  <div class="chart chart-sm">
                    <apexchart type="donut" :options="chart_agentes.options" :series="chart_agentes.series"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">Aliados por agentes Mes Actual</h5>
                </div>
                <div class="card-body">
                  <div class="chart chart-sm">
                    <apexchart type="donut" :options="chart_agentes_mes.options" :series="chart_agentes_mes.series">
                    </apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="agente != null">
            <div v-if="loading_resumen_aliados" class="text-center mt-4">
              <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div v-else>
              <transition appear name="slide-fade">
                <div class="row">
                  <div class="col-lg-5 d-flex align-items-stretch">
                    <div class="card card-body">
                      <div class="p-1">
                        <apexchart type="bar" :options="chart_aliados.options" :series="chart_aliados.series"></apexchart>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 d-flex align-items-stretch">
                    <div class="card card-body">
                      <div class="p-4">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="card card-body shadow p-1">
                              <h5 class="fw-bold text-orange">
                                Total de aliados: {{ total_aliados }}
                              </h5>
                            </div>
                            <div class="card card-body shadow p-1 mt-0">
                              <h5 class="fw-bold text-orange">
                                Total de aliados por
                                {{ agente.nombre_completo }}:
                                {{ total_aliados }}
                              </h5>
                            </div>
                          </div>
                          <div class="form-group col-lg-6">
                            <label>Ciudad</label>
                            <v-select v-model="sucursal" @input="get_aliados" label="sucursal"
                              :options="sucursales"></v-select>
                          </div>
                          <div class="form-group col-lg-6">
                            <label>Estado</label>
                            <select v-model="estado" v-on:change="get_aliados" class="form-control">
                              <option value="null">Todos</option>
                              <option value="0">Interesado</option>
                              <option value="1">Pendiente</option>
                              <option value="2">Completa</option>
                              <option value="3">Exitosa</option>
                            </select>
                          </div>
                          <div class="form-group col-lg-6">
                            <label>Tipo de descuento</label>
                            <select v-model="tipo_descuento" v-on:change="get_aliados" class="form-control">
                              <option value="null">Todos</option>
                              <option v-for="(
                                            tipo_descuento, index_tipo_descuento
                                          ) in tipos_descuento" v-bind:key="index_tipo_descuento"
                                v-bind:value="tipo_descuento.id_tipo_descuento">
                                {{ tipo_descuento.tipo_descuento }}
                              </option>
                            </select>
                          </div>

                          <div class="form-group col-lg-6">
                            <label>Categoría</label>
                            <select v-model="categoria" v-on:change="get_aliados" class="form-control">
                              <option value="null">Todas</option>
                              <option v-for="(
                                            categoria, index_categoria
                                          ) in categorias" v-bind:key="index_categoria"
                                v-bind:value="categoria.id_categoria">
                                {{ categoria.categoria }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group col-lg-4">
                            <label>Fase</label>
                            <select v-model="tipo_alianza" v-on:change="get_aliados" class="form-control">
                              <option value="null">Todos</option>
                              <option v-for="(
                                            tipo_alianza, index_tipo_alianza
                                          ) in tipos_alianza" v-bind:key="index_tipo_alianza"
                                v-bind:value="tipo_alianza.id_tipo_alianza">
                                {{ tipo_alianza.tipo_alianza }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group col-lg-4">
                            <label>Periodo de Facturación</label>
                            <!-- <label>Mes de registro</label> -->
                            <input v-on:change="get_aliados" v-model="fecha" type="month" class="form-control" />
                          </div>
                          <div class="form-group col-lg-4">
                            <label>Mes de completado</label>
                            <input v-on:change="get_aliados" v-model="fecha_completado" type="month"
                              class="form-control" />
                          </div>
                          <div class="col-lg-12">
                            <button class="btn btn-outline-primary btn-sm rounded-pill"
                              v-on:click="getLiquidacion($event)">
                              Liquidar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition appear name="slide-fade">
                <div class="row">
                  <div class="col-lg-12">
                    <div v-if="loading_aliados" class="text-center mt-4">
                      <div class="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="card card-body">
                        <div class="mt-3 mb-3 p-2 border text-orange bg-light">
                          <span class="fw-bold">Mes: <span v-if="fecha != null">{{ fecha }}</span><span
                              v-else>General</span>
                          </span>
                          -
                          <span class="fw-bold">Cantidad: {{ total_aliados_reporte }}
                          </span>
                        </div>
                        <table class="table table-bordered table-condensed table-hover my_table_1">
                          <thead>
                            <tr>
                              <th style="width: 2%">#</th>
                              <th style="width: 20%">Nombre</th>
                              <th class="text-center" style="width: 9%">
                                Estado
                              </th>
                              <th class="text-center" style="width: 15%">
                                Agente
                              </th>
                              <th class="text-center" style="width: 15%">
                                Fecha de Corte
                              </th>
                              <th style="width: 15%">
                                Comision Aliado
                              </th>
                              <th style="width: 15%">
                                Comision Piezas
                              </th>
                              <th class="text-center" style="width: 8%">
                                Opciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(aliado, index_aliado) in aliados" v-bind:key="index_aliado">
                              <td>{{ aliado.num }}</td>
                              <td>
                                <router-link v-bind:to="'/aliado/' + aliado.id_aliado">
                                  <h5 class="text-orange fw-bold mb-0">
                                    {{ aliado.nombre_aliado }}
                                  </h5>
                                </router-link>
                                <span class="fw-bold text-muted">
                                  {{ aliado.categoria }} </span><br />
                                <span v-if="aliado.sucursal != null" class="fw-bold text-muted">
                                  {{ aliado.sucursal.sucursal }}
                                </span>
                              </td>
                              <td class="text-center">
                                <span>
                                  <span v-if="aliado.estado_aliado == 0"
                                    class="badge bg-primary fw-bold">Interesado</span>
                                  <span v-if="aliado.estado_aliado == 1" class="badge bg-danger fw-bold">Pendiente</span>
                                  <span v-if="aliado.estado_aliado == 2" class="badge bg-success fw-bold">Completa</span>
                                  <span v-if="aliado.estado_aliado == 3" class="badge bg-warning fw-bold">Exitosa</span>
                                </span>
                              </td>
                              <td>
                                <div v-if="aliado.agente != null">
                                  <span class="text-uppercase">{{
                                    aliado.agente.usuario
                                  }}</span>
                                </div>
                                <small class="text-muted">
                                  {{ aliado.fecha_registro }}
                                </small>
                              </td>
                              <td class="text-center">
                                {{ aliado.fecha_corte }}
                              </td>
                              <td>
                                <div v-if="aliado.alianza">
                                  <div v-if="aliado.alianza.id_tipo_alianza == null">
                                    {{ 0 | currency }}
                                  </div>
                                  <div v-if="aliado.alianza.id_tipo_alianza == '1'">
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                                      {{ 0 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                                      {{ 20000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                                      {{ 15000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                                      {{ 12000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                                      {{ 12000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                                      {{ 12000 | currency }}
                                    </h4>
                                  </div>
                                  <div v-if="aliado.alianza.id_tipo_alianza == '2'">
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                                      {{ 0 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                                      {{ 40000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                                      {{ 30000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                                      {{ 25000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                                      {{ 15000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                                      {{ 12000 | currency }}
                                    </h4>
                                  </div>
                                  <div v-if="aliado.alianza.id_tipo_alianza == '3'">
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                                      {{ 0 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                                      {{ 65000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                                      {{ 45000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                                      {{ 35000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                                      {{ 25000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                                      {{ 15000 | currency }}
                                    </h4>
                                  </div>
                                  <div v-if="aliado.alianza.id_tipo_alianza == '5'">
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                                      {{ 0 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                                      {{ 40000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                                      {{ 30000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                                      {{ 25000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                                      {{ 15000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                                      {{ 12000 | currency }}
                                    </h4>
                                  </div>
                                  <div v-if="aliado.alianza.id_tipo_alianza == '6'">
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                                      {{ 0 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                                      {{ 40000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                                      {{ 30000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                                      {{ 25000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                                      {{ 15000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                                      {{ 12000 | currency }}
                                    </h4>
                                  </div>
                                  <div v-if="aliado.alianza.id_tipo_alianza == '7'">
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                                      {{ 0 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                                      {{ 20000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                                      {{ 15000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                                      {{ 12000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                                      {{ 12000 | currency }}
                                    </h4>
                                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                                      {{ 12000 | currency }}
                                    </h4>
                                  </div>
                                </div>
                                <div v-else>
                                  <h4>{{ 0 | currency }}</h4>
                                </div>
                              </td>
                              <td>
                                <h4 v-if="aliado.solicitud_pieza">
                                  {{ 5000 | currency }}
                                </h4>
                                <h4 v-else>
                                  {{ 0 | currency }}
                                </h4>
                              </td>
                              <td class="text-center">
                                <div class="dropdown">
                                  <a class="btn btn-outline-primary btn-sm rounded-pill dropdown-toggle"
                                    href="javascript:void(0)" role="button" id="dropdownMenuLink"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Opciones
                                  </a>

                                  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                                    <li>
                                      <router-link v-bind:to="
                                        '/aliado/ficha/' + aliado.id_aliado
                                      " class="dropdown-item">Ficha</router-link>
                                    </li>
                                    <li>
                                      <router-link v-bind:to="
                                        '/aliado/info_basica/' +
                                        aliado.id_aliado
                                      " class="dropdown-item">Editar</router-link>
                                    </li>

                                    <li>
                                      <router-link v-bind:to="
                                        '/aliado/anexos/' + aliado.id_aliado
                                      " class="dropdown-item">Anexos
                                      </router-link>
                                    </li>

                                    <li>
                                      <a v-on:click="
                                        show_modal_info_contrato(index_aliado)
                                      " href="javascript:void(0)" class="dropdown-item">Contrato</a>
                                    </li>

                                    <li>
                                      <a v-on:click="
                                        show_modal_pendientes(index_aliado)
                                      " href="javascript:void(0)" class="dropdown-item">Pendientes</a>
                                    </li>

                                    <li>
                                      <router-link v-bind:to="
                                        '/aliado/solicitudes/' +
                                        aliado.id_aliado
                                      " class="dropdown-item">Solicitudes de diseño</router-link>
                                    </li>

                                    <li v-if="session.usuario.perfil == 0">
                                      <a v-on:click="
                                        show_modal_eliminar(index_aliado)
                                      " href="javascript:void(0)" class="dropdown-item text-danger">Eliminar</a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="modal_eliminar" :adaptive="true" height="250">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-danger">Eliminar aliado</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null" class="text-danger">
            ¿Desea eliinar al aliado
            <strong>{{ aliados[index_select].nombre_aliado }}</strong>?
          </div>
          <hr />
          <div class="text-end">
            <button @click="eliminar" class="btn btn-danger rounded-pill">
              Sí
            </button>
            <button @click="$modal.hide('modal_eliminar')" class="btn btn-outline-secondary rounded-pill">
              No
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_pendientes" :adaptive="true" height="450">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Pendientes</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null">
            <div class="mb-3 text-orange">
              <h5 class="text-orange">
                <i class="bx bx-info-circle"></i> Información pendiente de
                <strong>{{ aliados[index_select].nombre_aliado }}</strong>
              </h5>
            </div>
            <table class="table table-bordered table-condensed table-hover">
              <thead>
                <tr v-if="aliados[index_select].info_legal == null">
                  <th>
                    <i class="bx bx-x-circle text-danger"></i> Información legal
                  </th>
                </tr>
                <tr v-if="
                  aliados[index_select].tipo_firma == 0 ||
                  aliados[index_select].tipo_firma == 2
                ">
                  <th><i class="bx bx-x-circle text-danger"></i> Contrato</th>
                </tr>
                <tr v-if="aliados[index_select].logo == null">
                  <th><i class="bx bx-x-circle text-danger"></i> Logo</th>
                </tr>
                <tr v-if="aliados[index_select].pieza_horizontal == null">
                  <th>
                    <i class="bx bx-x-circle text-danger"></i> Pieza revista
                  </th>
                </tr>
                <tr v-if="aliados[index_select].pieza_vertical == null">
                  <th>
                    <i class="bx bx-x-circle text-danger"></i> Pieza redes
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <hr />
          <div class="text-end">
            <button @click="$modal.hide('modal_pendientes')" class="btn btn-outline-secondary rounded-pill">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_info_contrato" :adaptive="true" height="450">
      <div class="card border m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Información de contrato</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null">
            <div class="mb-1 mt-1">
              Firmado:
              <h4 v-if="aliados[index_select].firma_contrato == 1" class="text-orange fw-bold">
                Sí
              </h4>
              <h4 v-else class="text-orange text-orange fw-bold">No</h4>
            </div>
            <div class="mb-1 mt-1">
              Tipo de firma:
              <h4 v-if="aliados[index_select].tipo_firma == 1" class="text-orange fw-bold">
                Electrónica
              </h4>
              <h4 v-if="aliados[index_select].tipo_firma == 2" class="text-warning fw-bold">
                Manual pendiente de aprobación
              </h4>
              <button v-on:click="aprobar_firma_manual" class="btn btn-orange rounded-pill" v-if="
                session.usuario.perfil == 0 &&
                aliados[index_select].tipo_firma == 2
              ">
                <i class="bx bx-check-circle"></i> Aprobar firma manual
              </button>
              <h4 v-if="aliados[index_select].tipo_firma == 3" class="text-warning text-orange fw-bold">
                Manual
              </h4>
              <h4 v-if="aliados[index_select].tipo_firma == 0" class="text-orange text-orange fw-bold">
                -
              </h4>
            </div>
            <div class="mb-3 mt-1">
              Fecha de firma:
              <h4 v-if="aliados[index_select].firma_contrato == 1" class="text-orange fw-bold">
                {{ aliados[index_select].fecha_firma }}
              </h4>
              <h4 v-else class="text-orange fw-bold">-</h4>
            </div>
            <div class="mb-1 mt-4 row">
              <div class="col-lg-4 text-center d-grid gap-2">
                <a class="btn btn-outline-primary btn-sm rounded-pill" v-bind:href="aliados[index_select].url_contrato"
                  target="_blank">
                  <i class="bx bx-file"></i> Contrato electrónico</a>
              </div>
              <div class="col-lg-4 text-center d-grid gap-2">
                <a v-if="
                  (aliados[index_select].tipo_firma == 2 ||
                    aliados[index_select].tipo_firma == 3) &&
                  aliados[index_select].contrato_fisico != null
                " class="btn btn-outline-primary btn-sm rounded-pill"
                  v-bind:href="aliados[index_select].contrato_fisico" target="_blank">
                  <i class="bx bx-download"></i> Descargar contrato</a>
                <a v-if="
                  aliados[index_select].tipo_firma == 0 &&
                  aliados[index_select].firma_contrato == 0
                " class="btn btn-outline-primary btn-sm rounded-pill"
                  v-on:click="generar_contrato(aliados[index_select].id_aliado)" href="javascript:void(0)">
                  <i class="bx bx-download"></i> Descargar contrato</a>
              </div>
            </div>
          </div>
          <hr />
          <div class="text-end">
            <button @click="$modal.hide('modal_info_contrato')" class="btn btn-outline-secondary rounded-pill">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_liquidacion" :adaptive="true" height="auto">
      <div class="card m-4" id="element-to-convert">
        <div class="card-header">
          <h2 class="fw-bold text-orange">Liquidacion Aliados</h2>
        </div>
        <div class="card-body" v-if="agente != null" style="height:70vh;overflow-y:scroll">
          <div class="row">
            <div class="col-md-12">
              <h2>Agente:</h2>
              <h4>{{ agente.nombre_completo }}</h4>
              <br>
            </div>
            <div class="col-md-6">
              <h2>Fecha generación:</h2>
              <h4>{{ today.getFullYear() + '-' + today.getMonth() + '-' + today.getDate() }}</h4>
              <br>
            </div>
            <div class="col-md-6">
              <h2>Fecha liquidada:</h2>
              <h4>{{ fecha }}</h4>
              <br>
            </div>
          </div>
          <h2>Detalle liquidación:</h2>
          <table class="table table-bordered table-condensed table-hover my_table_1">
            <thead>
              <tr>
                <th style="width: 2%">#</th>
                <th style="width: 20%">Nombre</th>
                <th style="width: 15%">
                  Comision Aliado
                </th>
                <th style="width: 15%">
                  Comision Piezas
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(aliado, index_aliado) in aliados" v-bind:key="index_aliado">
                <td>{{ aliado.num }}</td>
                <td>
                  <router-link v-bind:to="'/aliado/' + aliado.id_aliado">
                    <h5 class="text-orange fw-bold mb-0">
                      {{ aliado.nombre_aliado }}
                    </h5>
                  </router-link>
                  <span class="fw-bold text-muted">
                    {{ aliado.categoria }} </span><br />
                  <span v-if="aliado.sucursal != null" class="fw-bold text-muted">
                    {{ aliado.sucursal.sucursal }}
                  </span>
                </td>
                <td v-if="aliado.alianza">
                  <div v-if="aliado.alianza.id_tipo_alianza == null">
                    {{ 0 | currency }}
                  </div>
                  <div v-if="aliado.alianza.id_tipo_alianza == '1'">
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                      {{ 0 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                      {{ 20000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                      {{ 15000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                      {{ 12000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                      {{ 12000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                      {{ 12000 | currency }}
                    </h4>
                  </div>
                  <div v-if="aliado.alianza.id_tipo_alianza == '2'">
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                      {{ 0 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                      {{ 40000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                      {{ 30000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                      {{ 25000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                      {{ 15000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                      {{ 12000 | currency }}
                    </h4>
                  </div>
                  <div v-if="aliado.alianza.id_tipo_alianza == '3'">
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                      {{ 0 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                      {{ 65000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                      {{ 45000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                      {{ 35000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                      {{ 25000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                      {{ 15000 | currency }}
                    </h4>
                  </div>
                  <div v-if="aliado.alianza.id_tipo_alianza == '5'">
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                      {{ 0 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                      {{ 40000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                      {{ 30000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                      {{ 25000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                      {{ 15000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                      {{ 12000 | currency }}
                    </h4>
                  </div>
                  <div v-if="aliado.alianza.id_tipo_alianza == '6'">
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                      {{ 0 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                      {{ 40000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                      {{ 30000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                      {{ 25000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                      {{ 15000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                      {{ 12000 | currency }}
                    </h4>
                  </div>
                  <div v-if="aliado.alianza.id_tipo_alianza == '7'">
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '0'">
                      {{ 0 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '1'">
                      {{ 20000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '2'">
                      {{ 15000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '3'">
                      {{ 12000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '4'">
                      {{ 12000 | currency }}
                    </h4>
                    <h4 v-if="aliado.alianza.id_tipo_descuento == '5'">
                      {{ 12000 | currency }}
                    </h4>
                  </div>
                </td>
                <td>
                  <h4 v-if="aliado.solicitud_pieza">
                    {{ 5000 | currency }}
                  </h4>
                  <h4 v-else>
                    {{ 0 | currency }}
                  </h4>
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <h2>Total a Pagar:</h2>
          <h4>
            {{ total_liquidacion | currency }}
          </h4>
          <hr />
          <div class="text-end">
            <button class="btn btn-outline-secondary rounded-pill" @click="exportToPDF()">Export to PDF</button>
            <button @click="$modal.hide('modal_liquidacion')" class="btn btn-outline-secondary rounded-pill">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import { defineAsyncComponent } from 'vue';
import html2pdf from "html2pdf.js";
export default {
  name: "Panel_agentes",
  metaInfo: {
    title: "Panel de agentes - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      loading_resumen_aliados: false,
      loading_aliados: false,
      agentes: [],
      agente: null,
      chart_agentes: {
        options: {
          plotOptions: {
            pie: {
              size: 200,
              expandOnClick: true,
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true
                  }
                }
              }
            }
          },
          labels: []
        },
        series: [44, 55, 13, 33],
      },
      chart_agentes_mes: {
        options: {
          plotOptions: {
            pie: {
              size: 200,
              expandOnClick: true,
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true
                  }
                }
              }
            }
          },
          labels: []
        },
        series: [44, 55, 13, 33],
      },
      chart_aliados: {
        options: {
          plotOptions: {
            bar: {
              borderRadius: 10,
              distributed: true,
            },
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: ["Interesados", "Pendientes", "Exitosas", "Completas"],
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          colors: ["#6296FE", "#FF4D4D", "#FFC100", "#39BB00"],
        },
        series: [
          {
            name: "Aliados",
            data: [0, 0, 0, 0],
          },
        ],
      },
      today: new Date(),
      total_aliados: 0,
      vista: 2,
      sucursales: [],
      search: null,
      index_select: null,
      zona: null,
      categoria: null,
      tipo_alianza: null,
      aliados: [],
      sucursal: null,
      categorias: [],
      tipos_descuento: [],
      tipos_alianza: [],
      estado: null,
      tipo_descuento: null,
      fecha: null,
      fecha_completado: null,
      total_aliados_reporte: 0,
      total_liquidacion: 0,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    if (this.session.usuario.perfil != 0) {
      this.$router.push("/panel_aliados");
    }
    var agente_filtro = localStorage.getItem("agente_filtro");
    if (agente_filtro != undefined) {
      this.agente = JSON.parse(agente_filtro);
      this.get_resumen();
      this.get_aliados();
    }
    this.get_agentes();
    this.get_sucursales();
    this.get_tipos_descuento();
    this.get_tipos_alianzas();
    this.get_categorias();
    this.get_chart_data();
    this.get_chart_mes_data();
    this.chart_agentes.options.labels = JSON.parse(localStorage.getItem('agente_labels'))
    this.chart_agentes_mes.options.labels = JSON.parse(localStorage.getItem('agente_labels_mes'))
  },
  methods: {
    hasHistory() { return window.history.length > 2 },
    exportToPDF() {
      html2pdf(document.getElementById("element-to-convert"), {
        margin: 1,
        filename: "liquidacion.pdf",
      });
    },
    getLiquidacion: function () {
      this.total_liquidacion = 0;
      if (this.estado != 2 || this.fecha == null) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Solo se pueden liquidar los Aliados Completos con un periodo de facturacion seleccionado",
        });
      } else {
        let aliados = [];
        this.aliados.forEach(aliado => {
          let newAliado = aliado;
          switch (aliado.alianza.id_tipo_alianza) {
            case '1':
              switch (aliado.alianza.id_tipo_descuento) {
                case '0':
                  newAliado.liquidacion_aliado = 0;
                  break;
                case '1':
                  newAliado.liquidacion_aliado = 20000;
                  break;
                case '2':
                  newAliado.liquidacion_aliado = 15000;
                  break;
                case '3':
                  newAliado.liquidacion_aliado = 12000;
                  break;
                case '4':
                  newAliado.liquidacion_aliado = 12000;
                  break;
                case '5':
                  newAliado.liquidacion_aliado = 12000;
                  break;
              }
              break;
            case '2':
              switch (aliado.alianza.id_tipo_descuento) {
                case '0':
                  newAliado.liquidacion_aliado = 0;
                  break;
                case '1':
                  newAliado.liquidacion_aliado = 40000;
                  break;
                case '2':
                  newAliado.liquidacion_aliado = 30000;
                  break;
                case '3':
                  newAliado.liquidacion_aliado = 25000;
                  break;
                case '4':
                  newAliado.liquidacion_aliado = 15000;
                  break;
                case '5':
                  newAliado.liquidacion_aliado = 12000;
                  break;
              }
              break;
            case '3':
              switch (aliado.alianza.id_tipo_descuento) {
                case '0':
                  newAliado.liquidacion_aliado = 0;
                  break;
                case '1':
                  newAliado.liquidacion_aliado = 65000;
                  break;
                case '2':
                  newAliado.liquidacion_aliado = 45000;
                  break;
                case '3':
                  newAliado.liquidacion_aliado = 35000;
                  break;
                case '4':
                  newAliado.liquidacion_aliado = 25000;
                  break;
                case '5':
                  newAliado.liquidacion_aliado = 15000;
                  break;
              }
              break;
            case '5':
              switch (aliado.alianza.id_tipo_descuento) {
                case '0':
                  newAliado.liquidacion_aliado = 0;
                  break;
                case '1':
                  newAliado.liquidacion_aliado = 40000;
                  break;
                case '2':
                  newAliado.liquidacion_aliado = 30000;
                  break;
                case '3':
                  newAliado.liquidacion_aliado = 25000;
                  break;
                case '4':
                  newAliado.liquidacion_aliado = 15000;
                  break;
                case '5':
                  newAliado.liquidacion_aliado = 12000;
                  break;
              }
              break;
            case '6':
              switch (aliado.alianza.id_tipo_descuento) {
                case '0':
                  newAliado.liquidacion_aliado = 0;
                  break;
                case '1':
                  newAliado.liquidacion_aliado = 40000;
                  break;
                case '2':
                  newAliado.liquidacion_aliado = 30000;
                  break;
                case '3':
                  newAliado.liquidacion_aliado = 25000;
                  break;
                case '4':
                  newAliado.liquidacion_aliado = 15000;
                  break;
                case '5':
                  newAliado.liquidacion_aliado = 12000;
                  break;
              }
              break;
            case '7':
              switch (aliado.alianza.id_tipo_descuento) {
                case '0':
                  newAliado.liquidacion_aliado = 0;
                  break;
                case '1':
                  newAliado.liquidacion_aliado = 20000;
                  break;
                case '2':
                  newAliado.liquidacion_aliado = 15000;
                  break;
                case '3':
                  newAliado.liquidacion_aliado = 12000;
                  break;
                case '4':
                  newAliado.liquidacion_aliado = 12000;
                  break;
                case '5':
                  newAliado.liquidacion_aliado = 12000;
                  break;
              }
              break;
          }
          if (newAliado.solicitud_pieza) {
            newAliado.liquidacion_pieza = 5000
          } else {
            newAliado.liquidacion_pieza = 0
          }

          newAliado.liquidacion_total_aliado = newAliado.liquidacion_aliado + newAliado.liquidacion_pieza;
          this.total_liquidacion += newAliado.liquidacion_total_aliado;
          aliados.push(newAliado);
        });
        this.aliados = aliados;
        console.log(this.aliados)
        console.log(this.total_liquidacion)
        this.$modal.show("modal_liquidacion");
      }
    },
    get_agentes: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          agentes: 1,
        },
      };
      axios
        .get(this.$base_url + "admin/usuarios", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.agentes = response.data.data.usuarios;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_resumen: function () {
      if (this.agente == null) {
        return false;
      }
      this.loading_resumen_aliados = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          id_usuario: this.agente.id_usuario,
        },
      };
      axios
        .get(this.$base_url + "aliados/resumen_aliados", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.chart_aliados.series[0].data = response.data.data.chart;
          this.total_aliados = response.data.data.total;
          this.loading_resumen_aliados = false;
          this.get_aliados();
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_aliados: function () {
      this.loading_aliados = true;
      this.index_select = null;
      var id_sucursal = null;
      if (this.sucursal != null) {
        id_sucursal = this.sucursal.id_sucursal;
        // localStorage.setItem("sucursal", JSON.stringify(this.sucursal));
      }
      var search = null;
      if (this.search != null && this.search.trim().length != 0) {
        search = this.search;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      localStorage.setItem("agente_filtro", JSON.stringify(this.agente));
      let config = {
        headers: headers,
        params: {
          id_usuario: this.agente.id_usuario,
          id_sucursal: id_sucursal,
          estado: this.estado,
          tipo_descuento: this.tipo_descuento,
          zona: this.zona,
          tipo_alianza: this.tipo_alianza,
          categoria: this.categoria,
          search: search,
          fecha: this.fecha,
          fecha_completado: this.fecha_completado,
        },
      };
      axios
        .get(this.$base_url + "aliados/aliados", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliados = response.data.data.aliados;
          this.total_aliados_reporte = response.data.data.total_aliados;
          this.loading_aliados = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_sucursales: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/sucursales", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.sucursales = response.data.data.sucursales;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_tipos_descuento: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/tipos_descuentos", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.tipos_descuento = response.data.data.tipos_descuento;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_categorias: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/categorias", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.categorias = response.data.data.categorias;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_tipos_alianzas: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/tipos_alianzas", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.tipos_alianza = response.data.data.tipos_alianzas;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_chart_data: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
        },
      };
      axios
        .get(this.$base_url + "aliados/chart_aliados_agentes", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.chart_agentes.series = response.data.values;
          this.chart_agentes.options.labels = response.data.nombres;
          localStorage.setItem('agente_labels', JSON.stringify(response.data.nombres));
          console.log(response.data)
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_chart_mes_data: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
        },
      };
      axios
        .get(this.$base_url + "aliados/chart_aliados_agentes_mes", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: "No hay informacion para mostrar En el grafico Mensual",
            });
          }
          this.chart_agentes_mes.series = response.data.values;
          this.chart_agentes_mes.options.labels = response.data.nombres;
          localStorage.setItem('agente_labels_mes', JSON.stringify(response.data.nombres));
          console.log(response.data)
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    show_modal_eliminar: function (index) {
      this.index_select = index;
      this.$modal.show("modal_eliminar");
    },
    eliminar: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_aliado: this.aliados[this.index_select].id_aliado,
      };
      axios
        .post(this.$base_url + "aliados/eliminar_aliado", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Eliminado!",
              text: response.data.message,
            });
          }
          vm.index_select = null;
          vm.$modal.hide("modal_eliminar");
          vm.get_aliados();
          vm.get_resumen_aliados();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    show_modal_pendientes: function (index) {
      this.index_select = index;
      this.$modal.show("modal_pendientes");
    },
    show_modal_info_contrato: function (index) {
      this.index_select = index;
      this.$modal.show("modal_info_contrato");
    },
    generar_contrato(id_aliado) {
      window.open(this.$base_url + "download/contrato/" + id_aliado, "_blank");
    },
  },
  watch: {
    chart_agentes() {
      this.get_chart_data()
    }
  },
  mounted: function () { },
};
</script>